import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { resetData } from 'redux/actions/FinancialModelActions';
import FeedbackNav from './FeedbackNav';

const Feedback = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(resetData());
  }, [dispatch]);

  return (
    <div>
      <FeedbackNav />
    </div>
  );
};

export default Feedback;
